import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const NorthIndia = () => {
  return (
    <div>
      <div className="offices_div1">
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Workcave+Coworking/@30.7382526,76.7461474,17z/data=!3m1!4b1!4m5!3m4!1s0x390fedc262dee16b:0xdd0600ebc88e1bca!8m2!3d30.7381678!4d76.7482068?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Workcave+Coworking/@30.7382526,76.7461474,17z/data=!3m1!4b1!4m5!3m4!1s0x390fedc262dee16b:0xdd0600ebc88e1bca!8m2!3d30.7381678!4d76.7482068?coh=164777&entry=tt&shorturl=1"
              >
                Chandigarh
              </a>
              <p>
                Level 2, Seat No. 42, S.C.O. 224, Level 1 and 2,
                <br />
                Workcave, Sector-37-C, <br />
                Chandigarh, Punjab - 160 036
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Suits+Cafe/@26.865993,75.753375,17z/data=!3m1!4b1!4m6!3m5!1s0x396db5aaad517e95:0xf3fbef5e231606f5!8m2!3d26.865993!4d75.753375!16s%2Fg%2F11q2ykbvvq?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Suits+Cafe/@26.865993,75.753375,17z/data=!3m1!4b1!4m6!3m5!1s0x396db5aaad517e95:0xf3fbef5e231606f5!8m2!3d26.865993!4d75.753375!16s%2Fg%2F11q2ykbvvq?entry=ttu"
              >
                Jaipur, Rajasthan
              </a>
              <p>
                34/06 Kiran Path, Mansarovar, <br />
                Jaipur, Rajasthan - 302 020
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Next57+Coworking+Space+in+Mohali/@30.7069363,76.6191257,13z/data=!4m6!3m5!1s0x390fefc790d85c5b:0xbbb53b492bad3ae!8m2!3d30.7069363!4d76.6850437!16s%2Fg%2F11h1s3411g?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Next57+Coworking+Space+in+Mohali/@30.7069363,76.6191257,13z/data=!4m6!3m5!1s0x390fefc790d85c5b:0xbbb53b492bad3ae!8m2!3d30.7069363!4d76.6850437!16s%2Fg%2F11h1s3411g?entry=ttu"
              >
                Mohali, Punjab
              </a>
              <p>
                6th Floor, C-205, Phase-8B, Sahibzada, <br />
                Ajit Singh Nagar, <br /> Punjab - 140 308
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Srinagar, Jammu & Kashmir
              </a>
              <p>
                Ground Floor, Sector 1 Umerabad, <br />
                HMT Srinagar, <br /> Jammu & Kashmir - 190 012
              </p>
            </div>
          </div>
        </div>
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/MyBranch+Services+Pvt.+Ltd./@30.3562711,78.0813669,17z/data=!3m1!4b1!4m5!3m4!1s0x3908d784545cf5ad:0x5bc6894147cadd3!8m2!3d30.3562665!4d78.0855941?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/MyBranch+Services+Pvt.+Ltd./@30.3562711,78.0813669,17z/data=!3m1!4b1!4m5!3m4!1s0x3908d784545cf5ad:0x5bc6894147cadd3!8m2!3d30.3562665!4d78.0855941?coh=164777&entry=tt&shorturl=1"
              >
                Dehradun, Uttrakhand
              </a>
              <p>
                Ground Floor, Plot 21, Sahastradhara Road, <br />
                Doon IT Park, Danda Lakhond, <br />
                Dehradun, Uttrakhand - 248 001 
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Levana+Cyber+Heights/@26.867862,81.0099591,17z/data=!3m1!4b1!4m6!3m5!1s0x399be295be3524a9:0x329fad3755217788!8m2!3d26.867862!4d81.0099591!16s%2Fg%2F11f3xmr9lt?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Levana+Cyber+Heights/@26.867862,81.0099591,17z/data=!3m1!4b1!4m6!3m5!1s0x399be295be3524a9:0x329fad3755217788!8m2!3d26.867862!4d81.0099591!16s%2Fg%2F11f3xmr9lt?entry=ttu"
              >
                Lucknow, Uttar Pradesh
              </a>
              <p>
                212, 2nd Floor, Levana Cyber Heights, Vibhuti Khand, <br />
                Gomti Nagar, Lucknow, <br /> Uttar Pradesh - 226 010
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href="">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Shimla, Himachal Pradesh
              </a>
              <p>
                Happy Home, Laxmi Nagar, Sargeen, <br />
                Shimla, Himachal Pradesh - 171 009
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NorthIndia;
